import React from 'react'
import PropTypes from 'prop-types'

const MAX_LENGTH = 40

const UrlAsset = ({asset}) => {
  if (!asset.url) return (
    <div>Venter på leveranse</div>
  )

  let displayUrl = asset.url
  if (displayUrl.length > MAX_LENGTH) {
    displayUrl = `${displayUrl.substring(0, MAX_LENGTH)}...`
  }

  return (
    <a
      href={asset.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {displayUrl}
    </a>
  )
}

UrlAsset.propTypes = {
  asset: PropTypes.object.isRequired,
}

export default UrlAsset
